export default "__VITE_ASSET__Do8e_P0p__"